import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles } from '../../styles/AppTheme';

export class CampaignsAudioBO extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.pageKey = 'CampaignsAudioBO'
    this.pageTitle = Helper.getString('audio-ads')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.uploadLocation = this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['playlists'], queryParams: { iType: 'DEFAULT', pb: 'fieldDef' } },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => current.title,
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
    this.addNewLabel = 'Add Playlist'
    this.noTableHead = true
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDef
    this.setState({
      items: results[0].items
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['playlists']),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['playlists', current.id]),
    });
  }


  onActions(current) {
    const actions = []
    actions.push(
      <Link to={'/admin/audio-ads/' + current.id + '/items'} key={current.id + '-items'}>
        <Tooltip title='Media' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>playlist_play</i>
          </span>
        </Tooltip>
      </Link>
    )
    actions.push(UiHelper.buttonEdit(this, current))
    // actions.push(UiHelper.buttonDelete(this, current))
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/CampaignsAudioBO.js